type CustomerInvoiceItem = {
	id: number
	serviceSite: (Entity & { team: Entity | null }) | null
}

export enum WidgetType {
	supplier = 'supplier',
	customer = 'customer',
	recent = 'recent'
}

export enum InsightsFields {
	assignmentCompletionPrecentage = 'assignmentCompletionPrecentage',
	averageAssignmentScore = 'averageAssignmentScore',
	assignmentsOverduePercentage = 'assignmentsOverduePercentage',
	assignmentsIncompletePercentage = 'assignmentsIncompletePercentage',
	assignmentsAwaitingGradePercentage = 'assignmentsAwaitingGradePercentage'
}

export enum NotificationType {
	margins = 'MARGINS',
	customerInvoiceException = 'CUSTOMER_INVOICE_EXCEPTION',
	customerInvoiceMissing = 'CUSTOMER_INVOICE_SERVICE_MISSING_EXCEPTION'
}

export declare namespace Dashboard {
	namespace SupplierInvoiceQueueMyTeam {
		interface Basic {
			id: number
			supplierInvoiceNumber: BasicString
			supplierLocation: Nullable<Entity>
			status: Nullable<Entity>
			totalInvoiceAmount: BasicNumber
			currency: Nullable<Entity>
		}
	}
	namespace SupplierInvoice {
		interface Basic {
			id: number
			supplierInvoiceNumber: BasicString
			totalInvoiceAmount: BasicNumber
			supplierLocation: Entity | null
			status: Entity | null
			currency: Entity | null
		}
	}
	namespace CustomerInvoice {
		interface Basic {
			id: number
			number: BasicString
			customerInvoiceItems: CustomerInvoiceItem[]
			transactionCurrency: NameCode | null
			totalInvoiceAmount: BasicNumber
			customerInvoiceStatus: Entity | null
		}
	}

	namespace RecentReport {
		interface Basic {
			id: number
			name: BasicString
			runDate: BasicString
		}
	}

	namespace FavoriteReports {
		interface Basic extends Entity {}
	}

	namespace Learning {
		interface Basic {
			lessonName: string
			dateStarted: BasicString
			dateCompleted: string
			status: string
		}
	}
	namespace Insights {
		interface Basic {
			[InsightsFields.assignmentCompletionPrecentage]: number
			[InsightsFields.averageAssignmentScore]: number
			[InsightsFields.assignmentsOverduePercentage]: number
			[InsightsFields.assignmentsIncompletePercentage]: number
			[InsightsFields.assignmentsAwaitingGradePercentage]: number
		}
	}

	namespace Notification {
		interface Basic {
			id: number
			title: BasicString
			message: BasicString
			notificationType: NotificationType
			createDate: BasicString
			isRead: boolean
			redirectId?: BasicString
		}
	}
	namespace SupplierRequest {
		interface Basic extends Entity {
			statusId: BasicString
			statusName: BasicString
		}
	}

	namespace CustomerRequest {
		interface Basic {
			id: number
			assignedToContact: number
			createDate: BasicString
			createdBy: number
			customerContact: number
			customerEmailAddress: BasicString
			customerName: BasicString
			customerPhoneNumber: BasicString
			customerWebsite: BasicString
			lastUpdateDate: BasicString
			lastUpdatedBy: number
			status: Entity
		}
	}

	namespace ServiceRequest {
		interface Basic {
			items: {
				id: number
				trackingNumber: Key
				serviceRequestStatus: CodeEntity
				serviceSite: Entity
				supplierLocation: Entity
				createDate: BasicString
			}[]
			total: number
		}
	}
}
